// contexts/SalePageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { checkSalePageStatus } from '../../Services/ProductServices';

const SalePageContext = createContext();

export const SalePageProvider = ({ children }) => {
  const [isSaleEnabled, setIsSaleEnabled] = useState(false);

  useEffect(() => {
    const checkSaleStatus = async () => {
      try {
        const status = await checkSalePageStatus();
        setIsSaleEnabled(status.isEnabled);
      } catch (error) {
        console.error('Error checking sale status:', error);
        setIsSaleEnabled(false);
      }
    };

    checkSaleStatus();
  }, []);

  return (
    <SalePageContext.Provider value={{ isSaleEnabled }}>
      {children}
    </SalePageContext.Provider>
  );
};

export const useSalePage = () => {
  const context = useContext(SalePageContext);
  if (!context) {
    throw new Error('useSalePage must be used within a SalePageProvider');
  }
  return context;
};